import React, { memo } from 'react';

import { useIntl } from 'react-intl';

import { ActionsMenu } from '../../../components/ActionsMenu/ActionsMenu';
import { Box } from '../../../components/Box/Box';
import { Layout } from '../../../components/Layout/Layout';
import { Cell } from '../Cell/Cell';

export const RowActionCell = memo(({ row }) => {
  const isHeader = !Boolean(row);
  const intl = useIntl();

  return (
    <Cell
      align="right"
      as={isHeader ? 'th' : 'td'}
      flex="none"
      isPadded={false}
      stickyRight={0}
      style={{
        marginLeft: 'auto', // https://www.w3.org/TR/css-flexbox-1/#auto-margins
      }}
      render={() => {
        return isHeader ? (
          <Box px={4} />
        ) : (
          <Layout align="center">
            <ActionsMenu
              actions={row.actions}
              enablePortal
              id={row.actionsMenuId}
              name={intl.formatMessage(
                {
                  id: 'RowActionCell.moreActionsForRow',
                  defaultMessage: 'More actions for row {rowNumber}.',
                  description:
                    'Accessible name for row actions menu. Example: rowNumber = 1, 2, 3',
                },
                {
                  rowNumber: row.index + 1,
                },
              )}
              size="s"
            />
          </Layout>
        );
      }}
    />
  );
});
